import Swal from "sweetalert2"
import './sweet-alert-popup.css'
import {submitSecureLinkForm} from "../../components/secure-link";

$(function (){
    $(document).on("click", '.sweet-alert-popup', function (e) {
        e.preventDefault();

        const $el = $(this);
        const data = $el.data();

        Swal.fire({
            title: data.alertTitle,
            text: data.alertText,
            icon: data.alertIcon,
            showCancelButton: Boolean(data.alertShowCancelButton ?? false),
            confirmButtonText: data.alertConfirmButtonText,
            confirmButtonClass: data.alertConfirmButtonClass,
            cancelButtonText: data.alertCancelButtonText,
            cancelButtonClass: data.alertCancelButtonClass,
            closeButtonClass: data.alertCloseButtonClass,
        }).then((result) => {
            if (result.value === true) {
                // if element is inside x-secure-component then submit secure form
                const isSecureLinkFormSubmitted = submitSecureLinkForm($el);

                if (!isSecureLinkFormSubmitted) {
                    window.location.href = $(this).attr('href');
                }
            }
        })
    });

    $('.alert-remove').on("click", function (e) {
        console.warn('unsupported method, use x-secure-link instead');
        e.preventDefault();
        let id = $(this).attr('data-alert-id');
        let link = $(this).attr('data-alert-link');
        let title = $(this).attr('data-alert-title');
        let text = $(this).attr('data-alert-text');
        let confirmButton= $(this).attr('data-alert-button');

        Swal.fire({
            title: title,
            text: text,
            icon:"warning",
            showCancelButton: true,
            confirmButtonText: confirmButton,
            confirmButtonClass: "btn btn-danger btn-min-width",
            cancelButtonClass: "btn btn-primary btn-min-width",
            closeButtonClass: "btn btn-primary btn-min-width",
        }).then((result) => {
            if (result.value === true) {
                window.location.href = link;
            }
        })
    });

    $('.sa-success').on("click", function (e) {
        e.preventDefault();
        let id = $(this).attr('data-alert-id');
        let link = $(this).attr('data-alert-link');
        let title = $(this).attr('data-alert-title');
        let text = $(this).attr('data-alert-text');

        Swal.fire({
            title: title,
            text: text,
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#34c38f",
            confirmButtonClass: "btn btn-success btn-min-width",
        })
    });
});
